import {PassportUserTypes} from "root/Common/Constants/PassportUserTypes.mjs";

export const MenuPermissions = {
    canSeeEHCPHomeMenu: {
        description: 'User role who can see the Home Menus for EHCP',
        name: 'canSeeEHCPHomeMenu',
        default: true,
        authorities: {
            NCC: true,
            default: false
        },
    },
    canSeeEHCPAdminMenu: {
        description: 'User role who can see admin page for EHCP',
        name: 'canSeeEHCPAdminMenu',
        default: false,
        authorities: {
            NCC: true,
            default: false
        },
        allowedUserTypes: [PassportUserTypes.USER_TYPE_ADMIN, PassportUserTypes.USER_TYPE_EHCP_COORDINATOR, PassportUserTypes.USER_TYPE_EHCP_ADMIN, PassportUserTypes.USER_TYPE_EHCP_MANAGER],
        system: {
            EHCP: true,
            PASSPORT: false,
            default: false
        }
    },
    canSeeEHCPPanelsMenu: {
        description: 'User role who can see panels page for EHCP',
        name: 'canSeeEHCPPanelsMenu',
        default: false,
        authorities: {
            NCC: true,
            default: false
        },
        allowedUserTypes: [PassportUserTypes.USER_TYPE_ADMIN, PassportUserTypes.USER_TYPE_EHCP_COORDINATOR, PassportUserTypes.USER_TYPE_EHCP_GUEST, PassportUserTypes.USER_TYPE_EHCP_ADMIN, PassportUserTypes.USER_TYPE_EHCP_MANAGER],
        system: {
            EHCP: true,
            PASSPORT: false,
            default: false
        }
    },
    canSeeCOSAApplicationsMenu: {
        description: 'User role who can see applications page for EHCP',
        name: 'canSeeCOSAApplicationsMenu',
        default: false,
        authorities: {
            NCC: true,
            default: false
        },
        allowedUserTypes: [PassportUserTypes.USER_TYPE_ADMIN, PassportUserTypes.USER_TYPE_EHCP_COORDINATOR, PassportUserTypes.USER_TYPE_EHCP_ADMIN, PassportUserTypes.USER_TYPE_EHCP_MANAGER],
        system: {
            EHCP: true,
            PASSPORT: false,
            default: false
        }
    },
    canSeeCoOrdinatorQAMenu: {
        description: 'User role who can see the first stage QA for EHCP',
        name: 'canSeeCoOrdinatorQAMenu',
        default: false,
        authorities: {
            NCC: true,
            default: false
        },
        allowedUserTypes: [PassportUserTypes.USER_TYPE_ADMIN, PassportUserTypes.USER_TYPE_EHCP_COORDINATOR, PassportUserTypes.USER_TYPE_EHCP_ADMIN, PassportUserTypes.USER_TYPE_EHCP_MANAGER],
        system: {
            EHCP: true,
            PASSPORT: false,
            default: false
        }
    },
    canSeePendingPanelAssignmentMenu: {
        description: 'User role who can see the cases yet to be assigned to panel',
        name: 'canSeePendingPanelAssignmentMenu',
        default: false,
        authorities: {
            NCC: true,
            default: false
        },
        allowedUserTypes: [PassportUserTypes.USER_TYPE_ADMIN, PassportUserTypes.USER_TYPE_EHCP_COORDINATOR, PassportUserTypes.USER_TYPE_EHCP_ADMIN, PassportUserTypes.USER_TYPE_EHCP_MANAGER],
        system: {
            EHCP: true,
            PASSPORT: false,
            default: false
        }
    },
    canSeeRatifyMenu: {
        description: 'User role who can see the cases to ratify ( pre-approved )',
        name: 'canSeeRatifyMenu',
        default: false,
        authorities: {
            NCC: true,
            default: false
        },
        allowedUserTypes: [PassportUserTypes.USER_TYPE_ADMIN, PassportUserTypes.USER_TYPE_EHCP_COORDINATOR, PassportUserTypes.USER_TYPE_EHCP_ADMIN, PassportUserTypes.USER_TYPE_EHCP_MANAGER],
        system: {
            EHCP: true,
            PASSPORT: false,
            default: false
        }
    },
    canSeeToAssessMenu: {
        description: 'User role who can see the cases to assess ( approved at panel)',
        name: 'canSeeToAssessMenu',
        default: false,
        authorities: {
            NCC: true,
            default: false
        },
        allowedUserTypes: [PassportUserTypes.USER_TYPE_ADMIN, PassportUserTypes.USER_TYPE_EHCP_COORDINATOR, PassportUserTypes.USER_TYPE_EHCP_ADMIN, PassportUserTypes.USER_TYPE_EHCP_MANAGER],
        system: {
            EHCP: true,
            PASSPORT: false,
            default: false
        }
    },
    canSeePanelHistoryAssignmentMenu: {
        description: 'User role who can see historic ( Closed ) COSA Cases',
        name: 'canSeePanelHistoryAssignmentMenu',
        default: false,
        authorities: {
            NCC: true,
            default: false
        },
        allowedUserTypes: [PassportUserTypes.USER_TYPE_ADMIN, PassportUserTypes.USER_TYPE_EHCP_COORDINATOR, PassportUserTypes.USER_TYPE_EHCP_ADMIN, PassportUserTypes.USER_TYPE_EHCP_MANAGER],
        system: {
            EHCP: true,
            PASSPORT: false,
            default: false
        }
    },
    canSeeEHCPDashboardMenu: {
        description: 'User role who can see the EHCP Dashboard',
        name: 'canSeeEHCPDashboardMenu',
        default: false,
        authorities: {
            NCC: true,
            default: false
        },
        allowedUserTypes: [PassportUserTypes.USER_TYPE_ADMIN, PassportUserTypes.USER_TYPE_EHCP_COORDINATOR, PassportUserTypes.USER_TYPE_EHCP_ADMIN, PassportUserTypes.USER_TYPE_EHCP_MANAGER],
        system: {
            EHCP: true,
            PASSPORT: false,
            default: false
        }
    },
}
